export default "__VITE_ASSET__CsqsXAru__"